import React from 'react';
import styles from './StatusColumn.module.css';

function StatusColumn({ title, children }) {
  return (
    <div className={styles.column}>
      <h3>{title} ({React.Children.count(children)})</h3>
      <div className={styles.cardsContainer}>{children}</div>
    </div>
  );
}

export default StatusColumn;